// Icons
import { CloseRounded } from '@mui/icons-material';
import AddCircleIcon from '@mui/icons-material/AddCircle';

// Styled
import { FilterListCnt, FilterOption, CloseButton } from './styled';
import { useMemo } from 'react';
import { useCustomPermission } from 'utils/CustomHooks/useCustomPermission';

interface HeaderPropTypes {
  filterData?: any;
  renderCloseIcon?: boolean;
  handleClose?: () => void;
  hideFilters?: string;
  addFilter: (filterName: string) => void;
  readOnly?: boolean;
  handleSetFilters: (
    idx: number,
    filterData: {
      filterName?:
        | 'status'
        | 'startDate'
        | 'dueDate'
        | 'template'
        | 'assignee'
        | 'category'
        | 'location'
        | 'asset'
        | 'completedAt'
        | 'taskTemplates'
        | 'projects'
        | 'schedules'
        | 'createdBy'
        | '';
      comparator?: 'is' | 'isNot';
      value?: any[];
      conditional?: 'and' | 'or';
    },
  ) => void;
}

const FiltersList = ({
  filterData,
  hideFilters = '',
  addFilter,
  handleSetFilters,
  readOnly = false,
}: HeaderPropTypes) => {
  const { hasFeature, FEATURES } = useCustomPermission();

  const options = [
    {
      id: 'taskStatuses',
      key: 'taskStatuses',
      label: 'Status',
    },
    {
      id: 'templates',
      key: 'templates',
      label: 'Template Attached',
    },
    {
      id: 'templateSource',
      key: 'templateSource',
      label: 'Template Source',
    },
    {
      id: 'assignees',
      key: 'assignees',
      label: 'Assignee',
    },
    {
      id: 'categories',
      key: 'categories',
      label: 'Category',
    },
    {
      id: 'locations',
      key: 'locations',
      label: 'Location',
    },
    {
      id: 'assets',
      key: 'assets',
      label: 'Asset',
    },
    {
      id: 'createdDate',
      key: 'createdDate',
      label: 'Created Date',
    },
    {
      id: 'startDate',
      key: 'futureStartDate',
      label: 'Start Date',
    },
    {
      id: 'dueDate',
      key: 'futureDueDate',
      label: 'Due Date',
    },
    {
      id: 'startDate',
      key: 'startDate',
      label: 'Start Date',
    },
    {
      id: 'dueDate',
      key: 'dueDate',
      label: 'Due Date',
    },
    {
      id: 'completedDate',
      key: 'completedDate',
      label: 'Completed At',
    },
    {
      id: 'completedBy',
      key: 'completedBy',
      label: 'Completed By',
    },
    {
      id: 'archived',
      key: 'archived',
      label: 'Archived',
    },
    {
      id: 'taskTypes',
      key: 'taskTypes',
      label: 'Task Type',
    },
    {
      id: 'isOverDue',
      key: 'isOverDue',
      label: 'Overdue',
    },
    {
      id: 'priorities',
      key: 'priorities',
      label: 'Priority',
    },
    {
      id: 'scheduleFrequency',
      key: 'scheduleFrequency',
      label: 'Frequency',
    },
    {
      id: 'creators',
      key: 'creators',
      label: 'Created By',
    },
    {
      id: 'taskTemplates',
      key: 'taskTemplates',
      label: 'Task Template',
    },

    ...(hasFeature(FEATURES.PROJECTS)
      ? [
          {
            id: 'projects',
            key: 'projects',
            label: 'Projects',
          },
        ]
      : []),
    {
      id: 'schedules',
      key: 'schedules',
      label: 'Schedules',
    },
  ];

  const optionsAfterHideFilter = useMemo(
    () => options.filter((option) => !hideFilters?.includes(option.key)),
    [hideFilters],
  );

  return (
    <FilterListCnt>
      {optionsAfterHideFilter.map((option) => {
        const selected = filterData.find((x) => {
          return x.filterName === option.id;
        });
        return (
          <FilterOption
            key={option.id}
            selected={!!selected}
            onClick={() => !selected && !readOnly && addFilter(option.id)}
            disabled={readOnly}
          >
            {option.label}
            {!readOnly && <AddCircleIcon />}
          </FilterOption>
        );
      })}
    </FilterListCnt>
  );
};

export default FiltersList;
